module.exports = __webpack_public_path__ + "static/media/github.b3127335.svg";